import { useEffect, useState } from "react";
import { GoogleLogin } from "../cmps/login/google-login";
import { PasswordLogin } from "../cmps/login/password-login/password-login";
import scytaleLogo from '../assets/img/logo-scytale.png'
import { envService } from '../services/env-service'

export const LoginPage: React.FC = () => {
  const [nextStep, setNextStep] = useState<any>({})
  const [authError, setAuthError] = useState<string | null>(null)

  useEffect(() => {
    const error = sessionStorage.getItem('oauth_error')
    if (error) {
      setAuthError(error)
      sessionStorage.removeItem('oauth_error')
    }
  }, [])

  useEffect(() => {
    return () => {
      setNextStep({})
    }
  }, [setNextStep])

  const isPasswordLoginFlow = !!nextStep?.signInStep || !!nextStep?.resetPasswordStep

  return (
    <section className={`login-page ${!envService.isProd ? 'env-non-prod' : ''}`}>
      <div className="login-brand-panel">
        <div className="login-brand-content">
          <img src={scytaleLogo} alt="Logo" className="login-brand-logo" />
          <div className="login-brand-text">
            <span className="login-brand-label">ENTERPRISE</span>
            <span className="login-brand-title">BACKOFFICE</span>
            <span className="login-brand-env">{envService.label}</span>
          </div>
        </div>
      </div>

      <div className="login-form-panel">
        <div className="login-form-container">
          <div className="login-form-header">
            <h1>LOGIN</h1>
          </div>

          {authError && (
            <div className="login-auth-error">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
              <span>{authError}</span>
            </div>
          )}

          <PasswordLogin nextStep={nextStep} setNextStep={setNextStep} />

          <div className={`${isPasswordLoginFlow ? "invisible" : ""}`}>
            <div className="horizontal-title-container">
              <hr />
              <span>or</span>
              <hr />
            </div>
            <GoogleLogin hasAuthError={!!authError} />
          </div>
        </div>
      </div>
    </section>
  );
};
